import { ActivityContactCell } from './ActivityContactCell'
import { CellRendererParams } from '../EntityTable/types'
import { DataClassName } from '@/Data/const'

export const ActivityCompaniesCell = (params: CellRendererParams) => {
  return (
    <ActivityContactCell {...params} contactEntity={DataClassName.COMPANY} />
  )
}

export const ActivityCompaniesCellWithIcon = (params: CellRendererParams) => {
  return (
    <ActivityContactCell
      {...params}
      contactEntity={DataClassName.COMPANY}
      showIcon
    />
  )
}
